module.exports = __webpack_public_path__ + "img/dialog_bg_1.391ff05c.png";